module.exports = __webpack_public_path__ + "static/media/stock-1.2f4ce3de.jpg";